<template>
  <wrap-container>
    <help-title title="Seguros" />

    <help-list-container>
      <help-list-item tituloLista="Teléfonos útiles:">
        Te podes comunicar con el área de Seguros a través de nuestra Linea
        telefónica <strong>0800-999-4100</strong> de lunes a viernes de 10 a 18
        hs, a través del mail de clientes:
        <strong>clienteseguros-arg@bbva.com</strong>
      </help-list-item>
      <help-list-item tituloLista="Más información:">
        Encontrá más información sobre seguros en nuestro sitio
        <custom-link
          label="Ver más Información"
          href="https://www.bbva.com.ar/personas/productos/seguros.html"
        />
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import CustomLink from "@/components/core/CustomLink";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink,
    ContactLink
  }
};
</script>
